/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * Lutely API
 * Lutely API
 * OpenAPI spec version: local
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  FollowToggleResponseDto,
  LibraryControllerGetFollowedCreators200,
  LibraryControllerGetFollowedCreatorsParams,
  LibraryControllerGetSavedTracks200,
  LibraryControllerGetSavedTracksParams,
  LibraryDto,
  SaveToggleResponseDto,
} from ".././dtos";

import { apiRequest } from "../../api-request";
import type { ErrorType } from "../../api-request";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Get the current user's saved tracks/albums and followed creators
 */
export const libraryControllerGetLibrary = (
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<LibraryDto>(
    { url: `/library`, method: "GET", signal },
    options,
  );
};

export const getLibraryControllerGetLibraryQueryKey = () => {
  return [`/library`] as const;
};

export const getLibraryControllerGetLibraryQueryOptions = <
  TData = Awaited<ReturnType<typeof libraryControllerGetLibrary>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof libraryControllerGetLibrary>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof apiRequest>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getLibraryControllerGetLibraryQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof libraryControllerGetLibrary>>
  > = ({ signal }) => libraryControllerGetLibrary(requestOptions, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof libraryControllerGetLibrary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type LibraryControllerGetLibraryQueryResult = NonNullable<
  Awaited<ReturnType<typeof libraryControllerGetLibrary>>
>;
export type LibraryControllerGetLibraryQueryError = ErrorType<unknown>;

export function useLibraryControllerGetLibrary<
  TData = Awaited<ReturnType<typeof libraryControllerGetLibrary>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof libraryControllerGetLibrary>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof libraryControllerGetLibrary>>,
          TError,
          Awaited<ReturnType<typeof libraryControllerGetLibrary>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useLibraryControllerGetLibrary<
  TData = Awaited<ReturnType<typeof libraryControllerGetLibrary>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof libraryControllerGetLibrary>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof libraryControllerGetLibrary>>,
          TError,
          Awaited<ReturnType<typeof libraryControllerGetLibrary>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useLibraryControllerGetLibrary<
  TData = Awaited<ReturnType<typeof libraryControllerGetLibrary>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof libraryControllerGetLibrary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get the current user's saved tracks/albums and followed creators
 */

export function useLibraryControllerGetLibrary<
  TData = Awaited<ReturnType<typeof libraryControllerGetLibrary>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof libraryControllerGetLibrary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getLibraryControllerGetLibraryQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List the current user's saved tracks, most recent first
 */
export const libraryControllerGetSavedTracks = (
  params?: LibraryControllerGetSavedTracksParams,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<LibraryControllerGetSavedTracks200>(
    { url: `/library/tracks`, method: "GET", params, signal },
    options,
  );
};

export const getLibraryControllerGetSavedTracksQueryKey = (
  params?: LibraryControllerGetSavedTracksParams,
) => {
  return [`/library/tracks`, ...(params ? [params] : [])] as const;
};

export const getLibraryControllerGetSavedTracksQueryOptions = <
  TData = Awaited<ReturnType<typeof libraryControllerGetSavedTracks>>,
  TError = ErrorType<unknown>,
>(
  params?: LibraryControllerGetSavedTracksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof libraryControllerGetSavedTracks>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getLibraryControllerGetSavedTracksQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof libraryControllerGetSavedTracks>>
  > = ({ signal }) =>
    libraryControllerGetSavedTracks(params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof libraryControllerGetSavedTracks>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type LibraryControllerGetSavedTracksQueryResult = NonNullable<
  Awaited<ReturnType<typeof libraryControllerGetSavedTracks>>
>;
export type LibraryControllerGetSavedTracksQueryError = ErrorType<unknown>;

export function useLibraryControllerGetSavedTracks<
  TData = Awaited<ReturnType<typeof libraryControllerGetSavedTracks>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | LibraryControllerGetSavedTracksParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof libraryControllerGetSavedTracks>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof libraryControllerGetSavedTracks>>,
          TError,
          Awaited<ReturnType<typeof libraryControllerGetSavedTracks>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useLibraryControllerGetSavedTracks<
  TData = Awaited<ReturnType<typeof libraryControllerGetSavedTracks>>,
  TError = ErrorType<unknown>,
>(
  params?: LibraryControllerGetSavedTracksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof libraryControllerGetSavedTracks>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof libraryControllerGetSavedTracks>>,
          TError,
          Awaited<ReturnType<typeof libraryControllerGetSavedTracks>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useLibraryControllerGetSavedTracks<
  TData = Awaited<ReturnType<typeof libraryControllerGetSavedTracks>>,
  TError = ErrorType<unknown>,
>(
  params?: LibraryControllerGetSavedTracksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof libraryControllerGetSavedTracks>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List the current user's saved tracks, most recent first
 */

export function useLibraryControllerGetSavedTracks<
  TData = Awaited<ReturnType<typeof libraryControllerGetSavedTracks>>,
  TError = ErrorType<unknown>,
>(
  params?: LibraryControllerGetSavedTracksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof libraryControllerGetSavedTracks>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getLibraryControllerGetSavedTracksQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List the creators the current user follows, most recent first
 */
export const libraryControllerGetFollowedCreators = (
  params?: LibraryControllerGetFollowedCreatorsParams,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<LibraryControllerGetFollowedCreators200>(
    { url: `/library/creators`, method: "GET", params, signal },
    options,
  );
};

export const getLibraryControllerGetFollowedCreatorsQueryKey = (
  params?: LibraryControllerGetFollowedCreatorsParams,
) => {
  return [`/library/creators`, ...(params ? [params] : [])] as const;
};

export const getLibraryControllerGetFollowedCreatorsQueryOptions = <
  TData = Awaited<ReturnType<typeof libraryControllerGetFollowedCreators>>,
  TError = ErrorType<unknown>,
>(
  params?: LibraryControllerGetFollowedCreatorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof libraryControllerGetFollowedCreators>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getLibraryControllerGetFollowedCreatorsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof libraryControllerGetFollowedCreators>>
  > = ({ signal }) =>
    libraryControllerGetFollowedCreators(params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof libraryControllerGetFollowedCreators>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type LibraryControllerGetFollowedCreatorsQueryResult = NonNullable<
  Awaited<ReturnType<typeof libraryControllerGetFollowedCreators>>
>;
export type LibraryControllerGetFollowedCreatorsQueryError = ErrorType<unknown>;

export function useLibraryControllerGetFollowedCreators<
  TData = Awaited<ReturnType<typeof libraryControllerGetFollowedCreators>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | LibraryControllerGetFollowedCreatorsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof libraryControllerGetFollowedCreators>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof libraryControllerGetFollowedCreators>>,
          TError,
          Awaited<ReturnType<typeof libraryControllerGetFollowedCreators>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useLibraryControllerGetFollowedCreators<
  TData = Awaited<ReturnType<typeof libraryControllerGetFollowedCreators>>,
  TError = ErrorType<unknown>,
>(
  params?: LibraryControllerGetFollowedCreatorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof libraryControllerGetFollowedCreators>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof libraryControllerGetFollowedCreators>>,
          TError,
          Awaited<ReturnType<typeof libraryControllerGetFollowedCreators>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useLibraryControllerGetFollowedCreators<
  TData = Awaited<ReturnType<typeof libraryControllerGetFollowedCreators>>,
  TError = ErrorType<unknown>,
>(
  params?: LibraryControllerGetFollowedCreatorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof libraryControllerGetFollowedCreators>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List the creators the current user follows, most recent first
 */

export function useLibraryControllerGetFollowedCreators<
  TData = Awaited<ReturnType<typeof libraryControllerGetFollowedCreators>>,
  TError = ErrorType<unknown>,
>(
  params?: LibraryControllerGetFollowedCreatorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof libraryControllerGetFollowedCreators>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getLibraryControllerGetFollowedCreatorsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Toggle whether the current user saved a track
 */
export const libraryControllerToggleSaveTrack = (
  trackId: string,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<SaveToggleResponseDto>(
    { url: `/library/tracks/${trackId}/save-toggle`, method: "POST", signal },
    options,
  );
};

export const getLibraryControllerToggleSaveTrackMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof libraryControllerToggleSaveTrack>>,
    TError,
    { trackId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof libraryControllerToggleSaveTrack>>,
  TError,
  { trackId: string },
  TContext
> => {
  const mutationKey = ["libraryControllerToggleSaveTrack"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof libraryControllerToggleSaveTrack>>,
    { trackId: string }
  > = (props) => {
    const { trackId } = props ?? {};

    return libraryControllerToggleSaveTrack(trackId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LibraryControllerToggleSaveTrackMutationResult = NonNullable<
  Awaited<ReturnType<typeof libraryControllerToggleSaveTrack>>
>;

export type LibraryControllerToggleSaveTrackMutationError = ErrorType<unknown>;

/**
 * @summary Toggle whether the current user saved a track
 */
export const useLibraryControllerToggleSaveTrack = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof libraryControllerToggleSaveTrack>>,
      TError,
      { trackId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof libraryControllerToggleSaveTrack>>,
  TError,
  { trackId: string },
  TContext
> => {
  const mutationOptions =
    getLibraryControllerToggleSaveTrackMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Toggle whether the current user saved an album
 */
export const libraryControllerToggleSaveAlbum = (
  albumId: string,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<SaveToggleResponseDto>(
    { url: `/library/albums/${albumId}/save-toggle`, method: "POST", signal },
    options,
  );
};

export const getLibraryControllerToggleSaveAlbumMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof libraryControllerToggleSaveAlbum>>,
    TError,
    { albumId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof libraryControllerToggleSaveAlbum>>,
  TError,
  { albumId: string },
  TContext
> => {
  const mutationKey = ["libraryControllerToggleSaveAlbum"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof libraryControllerToggleSaveAlbum>>,
    { albumId: string }
  > = (props) => {
    const { albumId } = props ?? {};

    return libraryControllerToggleSaveAlbum(albumId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LibraryControllerToggleSaveAlbumMutationResult = NonNullable<
  Awaited<ReturnType<typeof libraryControllerToggleSaveAlbum>>
>;

export type LibraryControllerToggleSaveAlbumMutationError = ErrorType<unknown>;

/**
 * @summary Toggle whether the current user saved an album
 */
export const useLibraryControllerToggleSaveAlbum = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof libraryControllerToggleSaveAlbum>>,
      TError,
      { albumId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof libraryControllerToggleSaveAlbum>>,
  TError,
  { albumId: string },
  TContext
> => {
  const mutationOptions =
    getLibraryControllerToggleSaveAlbumMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Toggle whether the current user follows a creator
 */
export const libraryControllerToggleFollowCreator = (
  creatorId: string,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<FollowToggleResponseDto>(
    {
      url: `/library/creators/${creatorId}/follow-toggle`,
      method: "POST",
      signal,
    },
    options,
  );
};

export const getLibraryControllerToggleFollowCreatorMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof libraryControllerToggleFollowCreator>>,
    TError,
    { creatorId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof libraryControllerToggleFollowCreator>>,
  TError,
  { creatorId: string },
  TContext
> => {
  const mutationKey = ["libraryControllerToggleFollowCreator"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof libraryControllerToggleFollowCreator>>,
    { creatorId: string }
  > = (props) => {
    const { creatorId } = props ?? {};

    return libraryControllerToggleFollowCreator(creatorId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LibraryControllerToggleFollowCreatorMutationResult = NonNullable<
  Awaited<ReturnType<typeof libraryControllerToggleFollowCreator>>
>;

export type LibraryControllerToggleFollowCreatorMutationError =
  ErrorType<unknown>;

/**
 * @summary Toggle whether the current user follows a creator
 */
export const useLibraryControllerToggleFollowCreator = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof libraryControllerToggleFollowCreator>>,
      TError,
      { creatorId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof libraryControllerToggleFollowCreator>>,
  TError,
  { creatorId: string },
  TContext
> => {
  const mutationOptions =
    getLibraryControllerToggleFollowCreatorMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
